import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

import Layout from '../components/Layout'
import Hero from '../components/home/Hero'
import Audience from '../components/home/Audience'
import Issuers from '../components/home/Issuers'
import How from '../components/home/How'

import querySiteMetadata from '../staticQueries/querySiteMetadata'

export const HomeTemplate = ({ pageData, globalData }) => {

  return (
    <>
      <Hero data={pageData} newsletter={globalData ? globalData.newsletter : null} />
      <How data={pageData.how} />
      <Audience audience="individuals" data={pageData.individuals} />
      <Audience audience="businesses" data={pageData.businesses} />
      <Audience audience="schools" data={pageData.schools} />
      <Issuers data={pageData.issuers} />
    </>
  )
}

HomeTemplate.propTypes = {
  pageData: PropTypes.object,
  globalData: PropTypes.object,
}

const Home = ({ data }) => {
  const { title, description } = querySiteMetadata()
  const pageData = data.markdownRemark.frontmatter
  const globalData = data.allMarkdownRemark.edges[0].node.frontmatter

  return (
    <Layout footerData={globalData}>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:url" content="/" />
      </Helmet>
      <HomeTemplate
        pageData={pageData}
        globalData={globalData}
      />
    </Layout>
  )
}

Home.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export default Home

export const pageQuery = graphql`
  query HomeTemplate {
    allMarkdownRemark(filter: {frontmatter: {path: {eq: "/global"}}}) {
      edges {
        node {
          frontmatter {
            footer {
              heading
              body
            }
            newsletter {
              heading
              text
              action
            }
          }
        }
      }
    }
    markdownRemark(frontmatter: { templateKey: { eq: "home" } }) {
      frontmatter {
        heroTitle
        heroFg {
          childImageSharp {
            fluid(maxWidth: 2048, quality: 70) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        heroBg {
          childImageSharp {
            fluid(maxWidth: 2048, quality: 70) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        value
        how {
          heading
          background {
            childImageSharp {
              fluid(maxWidth: 2048, quality: 70) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          foreground {
            childImageSharp {
              fluid(maxWidth: 2048, quality: 70) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          foregroundMobile {
            childImageSharp {
              fluid(maxWidth: 800, quality: 70) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          body
        }
        issuers {
          heading
          background {
            childImageSharp {
              fluid(maxWidth: 2048, quality: 70) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          body
          Circles {
            text
          }
        }
        individuals {
          heading
          background {
            childImageSharp {
              fluid(maxWidth: 2048, quality: 70) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          foreground {
            childImageSharp {
              fluid(maxWidth: 2048, quality: 70) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          Circles {
            heading
            text
          }
        }
        businesses {
          heading
          background {
            childImageSharp {
              fluid(maxWidth: 2048, quality: 70) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          foreground {
            childImageSharp {
              fluid(maxWidth: 2048, quality: 70) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          Circles {
            heading
            text
          }
        }
        schools {
          heading
          background {
            childImageSharp {
              fluid(maxWidth: 2048, quality: 70) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          foreground {
            childImageSharp {
              fluid(maxWidth: 2048, quality: 70) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          Circles {
            heading
            text
          }
        }
      }
    }
  }
`
